export default "__VITE_ASSET__b0aaf057__"